import styled from "styled-components";

export const MainContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;

  @media (max-width: 768px) {
    height: auto;
    min-height: 100vh;
  }
`;

export const LeftPanel = styled.div`
  width: 60%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: var(--ads-v2-spaces-12);

  @media (max-width: 1024px) {
    width: 100%;
    padding-top: var(--ads-v2-spaces-8);
  }

  @media (max-width: 768px) {
    padding: var(--ads-v2-spaces-4) var(--ads-v2-spaces-3);
    padding-top: var(--ads-v2-spaces-6);
  }
`;

export const RightPanel = styled.div`
  width: 40%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const FormContainer = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;

  @media (max-width: 1024px) {
    width: 80%;
    min-width: 400px;
  }

  @media (max-width: 768px) {
    width: 100%;
    min-width: auto;
    max-width: 500px;
  }

  @media (max-width: 480px) {
    width: 100%;
    padding: 0 var(--ads-v2-spaces-2);
  }
`;

export const FormHeader = styled.div`
  text-align: left;
  margin-top: 40px;
`;

export const FormFooter = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;
  text-align: left;
  font-size: 14px;
  color: var(--ads-v2-color-fg-muted);
  margin-bottom: var(--ads-v2-spaces-4);
`;

export const FooterItem = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
`;

export const SubmitForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
  margin-bottom: 16px;

  && .bp3-label {
    color: var(--ads-v2-color-fg);
    margin-bottom: var(--ads-v2-spaces-2);
  }

  & a {
    font-size: ${(props) => props.theme.fontSizes[3]}px;
  }

  &:only-child {
    margin-right: 0;
  }

  .bp3-form-group {
    margin: 0;
  }
`;

export const FindOrganizationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid var(--ads-v2-color-border);
  padding-bottom: var(--ads-v2-spaces-5);
`;

export const FindOrganizationsForm = styled.form`
  display: flex;
  align-items: flex-start;
  gap: var(--ads-v2-spaces-3);
`;

export const FindOrganizationsDescription = styled.p`
  font-size: 12px;
  color: var(--ads-v2-color-fg);
  margin-top: var(--ads-v2-spaces-3);
  line-height: 1.4;
`;

export const SuccessMessageContainer = styled.div`
  background-color: var(--ads-v2-color-green-100);
  border-radius: var(--ads-v2-border-radius);
  padding: var(--ads-v2-spaces-4) var(--ads-v2-spaces-5);
  display: flex;
  align-items: flex-start;
  gap: var(--ads-v2-spaces-3);
`;

export const SuccessIcon = styled.div`
  width: 20px;
  height: 20px;
  background-color: var(--ads-v2-color-green-600);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SuccessContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--ads-v2-spaces-3);
`;

export const SuccessMessage = styled.p`
  font-size: 14px;
  color: var(--ads-v2-color-text-gray-500);
  margin: 0;
  font-weight: 400;
  line-height: 1.4;
`;

export const CloseButton = styled.button`
  cursor: pointer;
  color: var(--ads-v2-color-fg);
  font-size: 22px;
  line-height: 1;
`;

export const ResendEmailLink = styled.button`
  background: none;
  border: none;
  color: var(--ads-v2-color-gray-600);
  font-size: 14px;
  cursor: pointer;
  padding: 0;
  text-align: left;
  border-bottom: 1px solid var(--ads-v2-color-border);
  font-weight: 600;
  width: fit-content;

  @media (max-width: 480px) {
    font-size: 13px;
    padding: var(--ads-v2-spaces-1) 0;
  }

  &:hover {
    color: var(--ads-v2-color-gray-700);
  }

  &:focus {
    outline: 2px solid var(--ads-v2-color-border-emphasis);
    outline-offset: 2px;
  }
`;
